<template>
   <div class="competitionRight">
       <div class="upload" v-if="onOff">{{$t('global.报名参加')}}</div>
       <div class="upload" v-else>{{$t('global.上传作品')}}</div>
       <section class="wrap">
           <div class="head-wrap">
               <div class="head-line"></div>
             <h1 class="head">{{$t('global.举办方简介')}}</h1>
           </div>
           <div class="name-wrap">
               <img src="/static/sample/avatar.png" alt="">
               <strong class="name">MANA{{$t('global.全球艺术网络科技')}}</strong>
               <div class="icon-official"></div>
           </div>
           <div class="brif-wrap">
               <div class="brif">布鲁克林的艺术家们对我们地区的电影和艺术
                   场景感兴趣。发布您的视频分享想法计划见面会
                   或合作开始拍摄...</div>
               <div class="unfold">{{$t('global.展开')}} <img src="/static/specialCompetitiom/arrow.png" alt=""></div>
           </div>
       </section>
       <section class="wrap">
           <div class="head-wrap">
               <div class="head-line"></div>
               <h1 class="head">{{$t('global.时间')}}</h1>
           </div>
           <p class="time">{{$t('global.报名时间')}}：2017-09-23~2017-11-23</p>
           <p class="time">{{$t('global.举办时间')}}：2017-11-25~2017-11-30</p>
       </section>
   </div>

</template>

<script type="text/ecmascript-6">
    export default {
        name:'competitionRight',
        data(){
            return{

            }
        },
      props:["onOff"]
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.competitionRight
    width 3.8rem
    margin 0.4rem 0 0 0.2rem
    .wrap
        background-color #fff
        padding 0.39rem 0
        margin-top 0.2rem
        .time
            color #333333
            font-size 0.2rem
            padding 0.3rem 0 0 0.27rem
        .brif-wrap
            position relative
            font-size 0.16rem
            color #777777
            padding 0.2rem 0.26rem 0
        .unfold
            position absolute
            right 0.26rem
            color #0060ff
            bottom 0
        .name-wrap
            display flex
            justify-content space-around
            align-items center
            margin-top 0.5rem
            img
                display block
                width 0.5rem
                height 0.5rem
            .name
                font-size 0.2rem
                color #333333
            .icon-official
                width 0.24rem
                height 0.24rem
                background url("/static/specialCompetitiom/guan.png") no-repeat
                background-size cover
        .head-wrap
            display flex
            align-items center
            .head-line
                width 0.06rem
                height 0.19rem
                background-color #0161ff
                border-radius 0.03rem
            .head
                color #333333
                margin-left 0.2rem
                font-size 0.18rem
    .upload
        height 1rem
        color #fff
        text-align center
        font-size 0.26rem
        background-color #0161ff
        border-radius 0.08rem
        line-height 1rem
</style>



// WEBPACK FOOTER //
// src/components/competitionRight.vue